import PropTypes from 'prop-types';
var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
export default responsivePropType;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/system/esm/responsivePropType.js
// module id = 860
// module chunks = 121